import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=17e27ed3&scoped=true"
import script from "./judge.vue?vue&type=script&lang=js"
export * from "./judge.vue?vue&type=script&lang=js"
import style0 from "./judge.vue?vue&type=style&index=0&id=17e27ed3&prod&lang=scss&scoped=true"
import style1 from "./judge.vue?vue&type=style&index=1&id=17e27ed3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e27ed3",
  null
  
)

export default component.exports